import React, { useState } from 'react';

import { fetchPost as Post } from '@epi-helpers/FetchHelpers';
import { topupBenefitPending } from '@epi-api/topupLoad';

export const useTopupPendingBenefits = topupBeneficiariesIds => {
  const [isPendingBenefit, setIsPendingBenefit] = useState(false);

  const getPendingBenefits = async benefitType => {
    const payload = {
      beneficiaryIds: topupBeneficiariesIds,
      benefitType
    };

    const onSuccess = res => {
      setIsPendingBenefit(res.isTopUpLoadInProgress);
    };
    const onFailure = () => setIsPendingBenefit(false);

    Post(topupBenefitPending, payload, onSuccess).catch(onFailure);
  };

  return { isPendingBenefit, getPendingBenefits };
};
